import gql from "graphql-tag";

export default gql`
  mutation DeleteWorkOrder($id: ID!) {
    deleteWorkOrder(id: $id) {
      id
    }
  }
`;



// WEBPACK FOOTER //
// ./src/GraphQL/Mutations/DeleteWorkOrder.ts